// CancelToFreeModal Component
// Confirmation modal for canceling a paid plan and switching to Free

import React from 'react';
import { RevoltModal } from '../../../components/RevoltModal';
import { RevoltButton } from '../../../components/RevoltButton';
import { PlanSwitchCard } from './PlanSwitchCard';

export function CancelToFreeModal({
  isOpen,
  onClose,
  onConfirm,
  currentPlan,
  newPlan,
  message = "Switching to Free will cancel your current subscription immediately. Your credits won’t go down.",
}) {
  const handleConfirm = async () => {
    if (onConfirm) {
      await onConfirm();
    }
    onClose();
  };

  return (
    <RevoltModal
      isOpen={isOpen}
      onClose={onClose}
      title="Switch to Free"
      showCloseButton={false}
      containerClassName="plan-switch-modal"
    >
      <div>
        <div
          className="plan-cards-container"
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '12px',
            marginBottom: '24px',
            flexWrap: 'nowrap',
          }}
        >
          <PlanSwitchCard
            planData={currentPlan}
            billingCycle={currentPlan?.billingCycle}
          />

          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '48px',
            height: '48px',
            flexShrink: 0,
          }}>
            <svg
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ color: '#8b0000' }}
            >
              <path
                d="M9 18L15 12L9 6"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          <PlanSwitchCard
            planData={newPlan}
            billingCycle={newPlan?.billingCycle}
          />
        </div>

        <p style={{
          color: 'rgb(204, 204, 204)',
          fontSize: '15px',
          lineHeight: '1.6',
          textAlign: 'center',
          maxWidth: '700px',
          margin: '0 auto 20px',
        }}>
          {message}
        </p>

        <div style={{
          display: 'flex',
          gap: '12px',
          justifyContent: 'flex-end'
        }}>
          <RevoltButton
            variant="outline"
            onClick={onClose}
          >
            Cancel
          </RevoltButton>
          <RevoltButton
            variant="primary"
            onClick={handleConfirm}
          >
            Cancel Subscription
          </RevoltButton>
        </div>
      </div>
    </RevoltModal>
  );
}

export default CancelToFreeModal;

